// extracted by mini-css-extract-plugin
export default {"container":"asia_container__8FvT5","title":"asia_title__aHJpq"};